<template>
    <div class="sidebar">
        <div class="sidebar-inner">
            <div class="sidebar-topbar">
                <div class="company-section">
                    <avatar v-if="current.isLoaded" :background="current.membership.team.logo" ></avatar>
                </div>
            </div>
            <nav class="sidebar-nav">
                <div class="sidebar-nav-part">
                    <ul>
                        <li><router-link to="dashboard" data-to="dashboard"><svgicon name="dashboard"></svgicon><span class="inline-link-text"> Dashboard</span></router-link></li>
                        <li><router-link to="discover" data-to="discover"><svgicon name="directions"></svgicon><span class="inline-link-text"> Discover</span></router-link></li>
                        <li><router-link to="publish" data-to="publish"><svgicon name="create"></svgicon> Publish</router-link></li>
                        <li><router-link to="calendar" data-to="calendar"><svgicon name="calendar"></svgicon><span class="inline-link-text"> Planning</span></router-link></li>
                        <li><router-link to="insights" data-to="insights"><svgicon name="stats"></svgicon> Insights</router-link></li>
                    </ul>
                </div>
                <div class="sidebar-nav-part">
                    <div class="sidebar-nav-part-title">
                        <div class="sidebar-nav-part-title-text">tools</div>
                    </div>
                    <ul>
                        <li><router-link to="themes" data-to="themes"><svgicon name="goal"></svgicon><span class="inline-link-text"> Themes</span></router-link></li>
                        <li><svgicon name="star"></svgicon> Challenges</li>
                        <li><svgicon name="cup"></svgicon> Leaderboard</li>
                        <li><svgicon name="announcement"></svgicon> Announcements</li>
                    </ul>
                </div>
                <div class="sidebar-nav-part">
                    <div class="sidebar-nav-part-title">
                        <div class="sidebar-nav-part-title-text">team</div>
                    </div>
                    <ul>
                        <li><router-link to="users" data-to="users"><svgicon name="people"></svgicon><span class="inline-link-text"> Users</span></router-link></li>
                        <li><router-link to="groups" data-to="groups"><svgicon name="groups"></svgicon><span class="inline-link-text"> Groups</span></router-link></li>
                        <!--<li><svgicon name="pages"></svgicon> Social accounts</li>-->
                    </ul>
                </div>
                <div class="sidebar-nav-part">
                    <div class="sidebar-nav-part-title">
                        <div class="sidebar-nav-part-title-text">Settings</div>
                    </div>
                    <ul>
                        <li><router-link to="settings" data-to="settings"><svgicon name="settings"></svgicon><span class="inline-link-text"> Settings</span></router-link></li>
                        <li><router-link to="social-accounts" data-to="social-accounts"><svgicon name="accounts"></svgicon><span class="inline-link-text"> Social accounts</span></router-link></li>
                        <!--<li><svgicon name="buoy"></svgicon> Support</li>-->
                    </ul>
                </div>
                <div class="sidebar-nav-part">
                    <div class="sidebar-nav-part-title">
                        <div class="sidebar-nav-part-title-text">more</div>
                    </div>
                    <ul>
                        <li><a href="https://apostleconnect.com" target="_blank"><svgicon name="mortar"></svgicon> Skill center</a></li>
                        <li><a href="https://apostleconnect.com" target="_blank"><svgicon name="buoy"></svgicon> Support</a></li>
                    </ul>
                </div>
            </nav>
        </div>
    </div>
</template>
<script>
    import Avatar from "../../Avatar/Avatar";
    import { mapGetters } from 'vuex';
    import Context from '@/models/Context';

    export default {
        name: 'Sidebar',
        components: {
            Avatar
        },
        props: [],
        data () {
            return {

            }
        },
        computed: {
          isLoading: function() {
            return this._isLoading();
          },
          current: function() {
            if (!this.isLoading) {
              const context = Context.query()
                  .where(context => {
                    return context.id === 'current';
                  })
                  .first();
              if (context.isLoaded) {
                    return context;
                  }
            }

            return { loaded: false };
          },
        },
        mounted () {
        },
        methods: {
          ...mapGetters({
            _isLoading: 'entities/context/isLoading',
          })
        }
    }
</script>
<style src="./Sidebar.scss" scoped lang="scss"></style>

